import script from "./hours.and.date.form.vue?vue&type=script&lang=ts&setup=true"
export * from "./hours.and.date.form.vue?vue&type=script&lang=ts&setup=true"

import "./hours.and.date.form.vue?vue&type=style&index=0&id=2375bfb1&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2375bfb1"]])

export default __exports__